import { Tooltip } from "../../Tooltip/index.js";
import { MarkedText } from "./MarkedText.js";
import { cn } from "@synthesis/shared-utils";
import { jsx } from "react/jsx-runtime";
import { Select } from "@base-ui/react/select";
//#region src/Select/local-components/ListItem.tsx
const ListItem = ({ className, search, fetchItemTooltip, ...item }) => {
	const { value, tooltip } = item;
	const content = /* @__PURE__ */ jsx(Select.ItemText, { children: /* @__PURE__ */ jsx("span", {
		className: cn("paragraph-sm text-type-common bg-neutrals-white hover:bg-neutrals-95 focus:bg-neutrals-95 active:bg-neutrals-95 flex h-10 w-full cursor-pointer flex-nowrap items-center gap-2 border-none px-2.5 py-2 outline-none transition-colors", className),
		children: /* @__PURE__ */ jsx(ListItemContent, {
			item,
			search
		})
	}) });
	const fetchFunc = fetchItemTooltip ? async (signal) => ({ description: await fetchItemTooltip(item, signal) }) : void 0;
	const contentWrapped = tooltip || fetchFunc ? /* @__PURE__ */ jsx(Tooltip, {
		description: tooltip,
		triggerEvent: "mouse",
		arrowSide: "top",
		fetchData: fetchFunc,
		fetchDataId: value,
		children: content
	}) : content;
	return /* @__PURE__ */ jsx(Select.Item, {
		value,
		className: "cursor-pointer border-none outline-none",
		children: contentWrapped
	});
};
const ListItemContent = ({ item, search }) => {
	const { label } = item;
	if (typeof label === "string") return /* @__PURE__ */ jsx(MarkedText, {
		text: label,
		search
	});
	return label.map((chunk, index) => {
		const isStringItem = typeof chunk === "string";
		const content = isStringItem ? /* @__PURE__ */ jsx(MarkedText, {
			text: chunk,
			search,
			width: 1 / label.length * 100 + "%"
		}, index) : /* @__PURE__ */ jsx(MarkedText, {
			text: chunk.label,
			search,
			width: chunk.width ?? 1 / label.length * 100 + "%"
		}, index);
		if (isStringItem) return content;
		if (chunk.tooltip) return /* @__PURE__ */ jsx(Tooltip, {
			description: chunk.tooltip,
			triggerEvent: "mouse",
			arrowSide: "top",
			descriptionStyle: { wordBreak: "normal" },
			children: content
		}, index);
		if (chunk.fetchTooltip) {
			const fetchTooltipFunc = async (signal) => ({ description: await chunk.fetchTooltip(item, signal) });
			return /* @__PURE__ */ jsx(Tooltip, {
				description: "",
				triggerEvent: "mouse",
				arrowSide: "top",
				descriptionStyle: { wordBreak: "normal" },
				fetchData: fetchTooltipFunc,
				fetchDataId: `item-${item.value}-${index}`,
				children: content
			}, index);
		}
		return content;
	});
};
//#endregion
export { ListItem };

//# sourceMappingURL=ListItem.js.map